const LIST_MHP = document.querySelector('.mhp-development-list');
if (LIST_MHP) {
    function showErrorMessageDevMHPList(message) {
        document.getElementById('error-msg').classList.remove('hidden');
        document.getElementById('error-msg').innerHTML = `<p>${message}</p>`;
        document.querySelector('.mhp-development-list').classList.add('hidden');
    }

    async function getDataMhp() {
        let response = await fetch(`${APIPrefix.get()}/search_api/mhp/developments/list`);
        if (response.status == 200) {
            let data = await response.json();
            if (data.status == 'failure') {
                showErrorMessageDevMHPList(data.message);
                return data;
            } else if (data.status === '401') {
                APIUtils.redirectUserToSigninPage();
            } else {
                return data;
            }
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }

    getDataMhp().then((response) => {
      if (response.data) {
          for (const details in response.data.items) {
              const LI = document.createElement('li');
              LIST_MHP.appendChild(LI);
              for (const id in response.data.items[details].developmentIds) {
                let devBlock = buildDevelopmentBlock(response.data.items[details].developmentIds[id]);
                LI.appendChild(devBlock.element);

                let observer = new IntersectionObserver(handleIntersectMhp, devBlock.options);
                observer.observe(devBlock.element);
              }
          }
        }
    })
    .catch((e) => {
        console.log('Error::Development list::', e);
        let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : '';
        showErrorMessageDevMHPList(msg);
    });

    async function getInfoMhp(developmentId) {
      let infoResponse = await fetch(
          `${APIPrefix.get()}/search_api/mhp/developments/details?developmentId=${developmentId}`
      );
      if (infoResponse.status == 200) {
          let info = await infoResponse.json();
          if (info.status === '401') {
            APIUtils.redirectUserToSigninPage();
          } else {
              return info;
          }
      } else {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    async function getTableDataMhp(developmentId) {
      const NUMB_PER_PAGE = document.querySelector('.num-per-page').value;
      let response = await fetch(
        `${APIPrefix.get()}/search_api/mhp/properties/list?noOfItemsPerPage=${NUMB_PER_PAGE}&developmentId=${developmentId}`
      );
      if (response.status == 200) {
        let data = await response.json();
        if (data.status === '401') {
          APIUtils.redirectUserToSigninPage();
        } else {
          return data;
        }
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    function handleIntersectMhp(entries, observerMhp) {
        for (let entry of entries) {
            if (entry.isIntersecting) {
                observerMhp.unobserve(entry.target);
                let data_ID = entry.target.dataset.id;
                const developmentDiv = entry.target; //the div that is visible in viewport

                getInfoMhp(data_ID)
                    .then((info) => {
                    if (info.status == 'failure') {
                      developmentDiv.innerHTML = `
                          <div class="item-wrapper">
                            <div class="result-wrapper"> ${info.message}
                            </div>
                          </div>`;
                    } else {
                      let markup = `
                          <div class="item-wrapper">
                            <div class="result-wrapper"> 
                            </div>
                          </div>`;
                      if (info.data) {
                        let itemsInfo = info.data;
                        markup = `
                          <div class="item-wrapper">
                            <div class="result-wrapper">
                              <a title="${itemsInfo.viewDevelopmentButton.name}: ${itemsInfo.name}" href="${
                                  itemsInfo.viewDevelopmentButton.url
                                }" class="image-wrapper">
                                <img src="${itemsInfo.previewImage.path}" alt="${itemsInfo.previewImage.alt}">
                              </a>
                              <div class="content-wrapper">
                                <div class="content-info">
                                  <div class="info-wrapper">
                                    <h2>${itemsInfo.name}</h2>
                                    <span class="address">${itemsInfo.address}</span>
                                  </div>
                                  <div class="logo-content">
                                  ${
                                    itemsInfo.brand ?
                                      `<a title="${itemsInfo.brand.brandImage.alt}" href="${itemsInfo.brand.url}"><img src="${itemsInfo.brand.brandImage.path}" alt="${itemsInfo.brand.brandImage.alt}"></a>` :
                                      ``
                                  }
                                  </div>
                                </div>
                                <div class="bottom-wrapper">
                                
                                <p class="description">${itemsInfo.shortDescription}</p>
                                <div class="cta-wrapper">
                                <ul class="list-btns">
                                ${
                                  itemsInfo.meetTheTeamButton.url ?
                                    `<li>
                                       <a href="${itemsInfo.meetTheTeamButton.url}" title="${itemsInfo.name}: ${itemsInfo.meetTheTeamButton.name}"><svg role="img" aria-hidden="false" class="svg-panel svg-meet-the-team"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg/bg-icons.svg#svg-meet-the-team"></use></svg>${itemsInfo.meetTheTeamButton.name}</a>
                                     </li>` :
                                    ``
                                }
                                  ${
                                    itemsInfo.constructionProgressButton.url ?
                                      `<li>
                                         <a href="${itemsInfo.constructionProgressButton.url}" title="${itemsInfo.name}: ${itemsInfo.constructionProgressButton.name}"><svg role="img" aria-hidden="false" class="svg-panel svg-construction-progress"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg/bg-icons.svg#svg-construction-progress"></use></svg>${itemsInfo.constructionProgressButton.name}</a>
                                       </li>` :
                                      ``
                                  }
                                ${
                                  itemsInfo.aboutMyDevelopmentButton.url ?
                                    `<li>
                                       <a href="${itemsInfo.aboutMyDevelopmentButton.url}" title="${itemsInfo.name}: ${itemsInfo.aboutMyDevelopmentButton.name}"><svg role="img" aria-hidden="false" class="svg-panel svg-about-my-development"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/images/svg/bg-icons.svg#svg-about-my-development"></use></svg>${itemsInfo.aboutMyDevelopmentButton.name}</a>
                                     </li>` :
                                    ``
                                }
                                </ul>
                                
                                  <a href="${itemsInfo.viewDevelopmentButton.url}" title="${
                                    itemsInfo.viewDevelopmentButton.name
                                  }: ${itemsInfo.name}" class="button button--primary">${
                                    itemsInfo.viewDevelopmentButton.name
                                  } </a>
                                </div>
                                </div>
                              </div>
                            </div>
                            <div class="table-results-wrapper">
                              <div class="property-list-component alt-background">
                                <input type="hidden" class="num-per-page" value="2">
                                <input type="hidden" class="data-source-page-id" value="">
                                <div class="table-wrapper">
                                <div class="list-loader"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          `;
                      }
                      developmentDiv.innerHTML = markup;

                      let wrap = developmentDiv.querySelector('.table-results-wrapper');

                      getTableDataMhp(developmentDiv.id)
                        .then((response) => {
                        if (response.status == 'failure') {
                          const TABLE_WRAPPER = wrap.querySelector('.property-list-component .table-wrapper');
                          TABLE_WRAPPER.innerText = response.message;
                        } else {
                          if (response.data) {
                            const HEADINGS = response.data.headings;
                            const ITEMS = response.data.items;
                            const CONFIGURATION = response.data.configuration;
                            const PROP_LIST_TAB = wrap.querySelector('.property-list-component');
                            const TABLE_WRAPPER = wrap.querySelector('.property-list-component .table-wrapper');
                            TABLE_WRAPPER.innerText = '';
                            const TABLE = document.createElement('table');
                            TABLE.setAttribute('class', 'pagination');
                            TABLE_WRAPPER.appendChild(TABLE);
                            PROP_LIST_TAB.appendChild(TABLE_WRAPPER);
                            for (const field in response.data) {
                              const THEAD = document.createElement('thead');
                              const TABLE_ROW = document.createElement('tr');
                              THEAD.appendChild(TABLE_ROW);
                              const TBODY = document.createElement('tbody');
                              // create headings
                              if (field == 'headings') {
                                for (const child in HEADINGS) {
                                  const HEADER_CELL = document.createElement('th');
                                  TABLE_ROW.appendChild(HEADER_CELL);
                                  HEADER_CELL.innerText = HEADINGS[child];
                                  TABLE.appendChild(THEAD);
                                }
                                const HEADER_CELL = document.createElement('th');
                                HEADER_CELL.classList.add('disabled-sorting');
                                TABLE_ROW.appendChild(HEADER_CELL);
                                TABLE.appendChild(THEAD);
                              } else if (field == 'items') {
                                for (const child in ITEMS) {
                                  const TABLE_ROW = document.createElement('tr');
                                  let item = ITEMS[child].fields;
                                  let btn = ITEMS[child].button;
                                  for (const row in item) {
                                    const TABLE_DATA = document.createElement('td');
                                    TABLE_ROW.appendChild(TABLE_DATA);
                                    if (typeof item[row] === 'object' && item[row] !== null) {
                                      if (row === 'propertynumber') {
                                        let link = document.createElement('a');
                                        link.setAttribute('class', 'propertynumber');
                                        link.setAttribute('title', item[row].tooltip);
                                        link.setAttribute('href', item[row].url);
                                        link.innerHTML = item[row].name;
                                        TABLE_DATA.appendChild(link);
                                      } else {
                                        let link;
                                        if ((row === 'propertyactionrequired') && (item[row].state === 'active')) {
                                          link = document.createElement('button');
                                          link.setAttribute('type', 'button');
                                        } else {
                                          link = document.createElement('a');
                                        }
                                        link.setAttribute('title', item[row].tooltip);
                                        const hoverIcon = item[row].hoverIconPath ? item[row].hoverIconPath : item[row].activeIconPath;
                                        const activeIcon = item[row].activeIconPath ? item[row].activeIconPath : '';
                                        const disabledIcon = item[row].disabledIconPath ? item[row].disabledIconPath : '';
                                        if (row === 'propertyactionrequired') {
                                          if (item[row].state === 'active') {
                                            link.setAttribute('data-modal', 'notificationsModal');
                                            link.setAttribute('class', 'notifications-btn mhp-link-icon');
                                            link.setAttribute('tabindex', '0');
                                            link.innerHTML = `<img data-disabled="${disabledIcon}" data-active="${activeIcon}" data-hover="${hoverIcon}" class="mhp-icon-link" src="${
                                              item[row][`${item[row].state}IconPath`]
                                            }">`;
                                          }
                                        } else {
                                          if (item[row].state === 'active') {
                                            link.setAttribute('href', item[row].url);
                                            link.setAttribute('class', 'mhp-link-icon icon-active');
                                          } else {
                                            link.setAttribute('class', 'mhp-link-icon icon-disabled');
                                            link.removeAttribute('title');
                                          }
                                          link.innerHTML = `<img data-disabled="${disabledIcon}" data-active="${activeIcon}" data-hover="${hoverIcon}" class="mhp-icon-link" src="${
                                            item[row][`${item[row].state}IconPath`]
                                          }">`;
                                        }
                                        TABLE_DATA.appendChild(link);
                                      }
                                    } else {
                                      TABLE_DATA.innerText = item[row];
                                    }
                                    TBODY.appendChild(TABLE_ROW);
                                    TABLE.appendChild(TBODY);
                                  }
                                  if (btn.url !== '') {
                                    let link = document.createElement('a');
                                    link.setAttribute('title', btn.tooltip);
                                    link.setAttribute('href', btn.url);
                                    link.innerHTML = btn.name;
                                    link.setAttribute('class', 'button button--primary');
                                    link.setAttribute('title', btn.name);
                                    let NEW_CELL = TABLE_ROW.insertCell(-1);
                                    NEW_CELL.appendChild(link);
                                  } else {
                                    let link = document.createElement('span');
                                    link.innerHTML = btn.name;
                                    let NEW_CELL = TABLE_ROW.insertCell(-1);
                                    NEW_CELL.appendChild(link);
                                  }
                                }
                              }
                            }
                            if (ITEMS !== undefined && ITEMS.length !== 0) {
                              let dataTable = tableUtils.initPaginatedDataTable(developmentDiv, CONFIGURATION, true, true);

                              let paginationWrapper = developmentDiv.querySelector('.dataTable-pagination');
                              if (paginationWrapper && paginationWrapper.hasChildNodes()) {

                                tableUtils.initPaginationControlStates(dataTable, paginationWrapper);
                                tableUtils.displayFirstPageAfterSort(dataTable, developmentDiv);
                              }
                              const ICONS_STATES_FLOW = developmentDiv.querySelectorAll('.icon-active .mhp-icon-link');
                              if (ICONS_STATES_FLOW) {
                                ICONS_STATES_FLOW.forEach((icon) => {
                                  icon.addEventListener('mouseover', (e) => {
                                    const hoverIcon = e.target.getAttribute('data-hover');
                                    e.target.src = hoverIcon;
                                  });
                                  icon.addEventListener('mouseout', (e) => {
                                    const activeIcon = e.target.getAttribute('data-active');
                                    e.target.src = activeIcon;
                                  });
                                });
                              }
                            }
                          } else {
                            const TABLE_WRAPPER = wrap.querySelector('.property-list-component .table-wrapper');
                            TABLE_WRAPPER.innerText = '';
                          }
                        }
                      })
                      .catch((e) => {
                        console.log('Error::Property List::', e);
                        let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : '';
                        const TABLE_WRAPPER = wrap.querySelector('.property-list-component .table-wrapper');
                        TABLE_WRAPPER.innerText = msg;
                      });
                    }
                })
          .catch((e) => {
            console.log('Error::Development details::', e);
            let msg = document.querySelector('.rest-message--fail').value ? document.querySelector('.rest-message--fail').value : '';
            developmentDiv.innerHTML = `
          <div class="item-wrapper">
            <div class="result-wrapper">${msg}
            </div>
          </div>`;
          });
            }
        }
    }
}